
import PagePublic2Col from '../../components/Page/PagePublic2Col';
import ForgotCard from './ForgotCard';
import { IMAGE_RUN } from '../../constants';


export default function ForgotWelcome() {
  return (
    <PagePublic2Col
      leftsideimage={IMAGE_RUN}
      brandtext="Preventive Health Intelligence"
      headline=""
      formcomp={<ForgotCard />}
    />
  );
}
